// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc, TradePartnerContactFragmentDoc, TradePartnerFragmentDoc, HistoryFeedInfoFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DuplicateItemsConfirmationModal_GetTlisQueryVariables = Types.Exact<{
  filter: Types.TakeoffLineItemFilter;
}>;


export type DuplicateItemsConfirmationModal_GetTlisQuery = { __typename?: 'Query', takeoffLineItemsPage: { __typename?: 'TakeoffLineItemsPage', items: Array<{ __typename?: 'TakeoffLineItem', id: string, name: string, canDuplicate: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };


export const DuplicateItemsConfirmationModal_GetTlisDocument = gql`
    query DuplicateItemsConfirmationModal_GetTlis($filter: TakeoffLineItemFilter!) {
  takeoffLineItemsPage(filter: $filter) {
    items {
      id
      name
      canDuplicate {
        ...PotentialOperationDetails
      }
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;

/**
 * __useDuplicateItemsConfirmationModal_GetTlisQuery__
 *
 * To run a query within a React component, call `useDuplicateItemsConfirmationModal_GetTlisQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateItemsConfirmationModal_GetTlisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateItemsConfirmationModal_GetTlisQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDuplicateItemsConfirmationModal_GetTlisQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DuplicateItemsConfirmationModal_GetTlisQuery, DuplicateItemsConfirmationModal_GetTlisQueryVariables> & ({ variables: DuplicateItemsConfirmationModal_GetTlisQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DuplicateItemsConfirmationModal_GetTlisQuery, DuplicateItemsConfirmationModal_GetTlisQueryVariables>(DuplicateItemsConfirmationModal_GetTlisDocument, options);
      }
export function useDuplicateItemsConfirmationModal_GetTlisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DuplicateItemsConfirmationModal_GetTlisQuery, DuplicateItemsConfirmationModal_GetTlisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DuplicateItemsConfirmationModal_GetTlisQuery, DuplicateItemsConfirmationModal_GetTlisQueryVariables>(DuplicateItemsConfirmationModal_GetTlisDocument, options);
        }
export function useDuplicateItemsConfirmationModal_GetTlisSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DuplicateItemsConfirmationModal_GetTlisQuery, DuplicateItemsConfirmationModal_GetTlisQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DuplicateItemsConfirmationModal_GetTlisQuery, DuplicateItemsConfirmationModal_GetTlisQueryVariables>(DuplicateItemsConfirmationModal_GetTlisDocument, options);
        }
export type DuplicateItemsConfirmationModal_GetTlisQueryHookResult = ReturnType<typeof useDuplicateItemsConfirmationModal_GetTlisQuery>;
export type DuplicateItemsConfirmationModal_GetTlisLazyQueryHookResult = ReturnType<typeof useDuplicateItemsConfirmationModal_GetTlisLazyQuery>;
export type DuplicateItemsConfirmationModal_GetTlisSuspenseQueryHookResult = ReturnType<typeof useDuplicateItemsConfirmationModal_GetTlisSuspenseQuery>;
export type DuplicateItemsConfirmationModal_GetTlisQueryResult = Apollo.QueryResult<DuplicateItemsConfirmationModal_GetTlisQuery, DuplicateItemsConfirmationModal_GetTlisQueryVariables>;